import { useEffect, useState } from 'react';
import { API_BASE } from '../client/config';

// =============================================================================
// 현재 세션 조직이 삭제 예정(soft-delete) 상태인지 반환. 디바이스 등 콘텐츠 화면에서
// Only Read 처리·안내 배너 노출에 사용. 조회 실패/권한 없음 → false(서버 가드가
// 실제 쓰기를 막으므로 UI는 fail-open).
// =============================================================================

export function useCurrentOrgDeleted(): boolean {
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    const ac = new AbortController();
    fetch(`${API_BASE}/api/orgs/current/detail`, { signal: ac.signal })
      .then((r) => (r.ok ? (r.json() as Promise<{ org?: { deletedAt?: string | null } }>) : null))
      .then((d) => {
        if (ac.signal.aborted) return;
        setDeleted(Boolean(d?.org?.deletedAt));
      })
      .catch(() => {
        if (!ac.signal.aborted) setDeleted(false);
      });
    return () => ac.abort();
  }, []);

  return deleted;
}
